export default "__VITE_ASSET__6c06b5cc__"